"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatusType = exports.GenderType = void 0;
var GenderType;
(function (GenderType) {
    GenderType["male"] = "male";
    GenderType["female"] = "female";
})(GenderType || (exports.GenderType = GenderType = {}));
var StatusType;
(function (StatusType) {
    StatusType["pending"] = "pending";
    StatusType["approved"] = "approved";
    StatusType["rejected"] = "rejected";
})(StatusType || (exports.StatusType = StatusType = {}));
//# sourceMappingURL=interface.js.map